// extracted by mini-css-extract-plugin
module.exports = {"CustomOverlay":"CustomWithSpinner_CustomOverlay__jK_03","SpinnerContainer":"CustomWithSpinner_SpinnerContainer__dy60r"};